import React from 'react';
import { Container } from 'vendors/semantic-ui';

import { buildComponentArray } from 'modules/shared/utils';
import { readCMSValue, getDefault } from 'modules/shared-cms/utils';

import {
    TitleBloc,
    ArticleProps,
    Article,
    ImagesBloc,
    RibbonBlocContainer,
} from 'modules/shared-cms-advanced/components';
import { HtmlContainer } from 'modules/shared-ui/components';

import { AdvantageImagesBloc, ComparisonTable, StepListBlock, TextContentBlock } from '../cms';

import { ListChoiceProps } from './list-choice-type';

import styles from './list-choice-component.module.css';

export const ListChoiceComponent: React.FC<ListChoiceProps> = React.memo(
    ({
        articles,
        imagesTitle: wrappedImgsTitle,
        images: wrappedImages,
        avantages: wrappedAvantages,
        mentions: wrappedMentions,
        ...rest
    }: ListChoiceProps) => {
        const {
            imagesTitle = getDefault(readCMSValue(wrappedImgsTitle), ''),
            imgs = readCMSValue(wrappedImages),
            mentions = getDefault(readCMSValue(wrappedMentions), ''),
            assets = readCMSValue(wrappedAvantages),
            textContentBlock1 = {
                color: rest.tcb1BackgroundColor,
                textColor: rest.tcb1TextColor,
                title: rest.tcb1Title,
                fontSizeTitle: rest.tcb1FontSizeTitle,
                subTitle: rest.tcb1Subtitle,
                fontSizeSubTitle: rest.tcb1FontSizeSubtitle,
                ctaText1: rest.tcb1CtaText1,
                ctaLink1: rest.tcb1CtaLink1,
                ctaStyle1: rest.tcb1CtaStyle1,
                ctaText2: rest.tcb1CtaText2,
                ctaLink2: rest.tcb1CtaLink2,
                ctaStyle2: rest.tcb1CtaStyle2,
                ctaText3: rest.tcb1CtaText3,
                ctaLink3: rest.tcb1CtaLink3,
                ctaStyle3: rest.tcb1CtaStyle3,
            },
            steps = getDefault(readCMSValue(rest.steps), []),
            comparisonTableProps = {
                color: rest.ctBackgroundColor,
                textColor: rest.ctTextColor,
                title: rest.ctTitle,
                fontSizeTitle: rest.ctFontSizeTitle,
                subTitle: rest.ctSubtitle,
                fontSizeSubTitle: rest.ctFontSizeSubtitle,
                ctaText: rest.ctCtaText,
                ctaLink: rest.ctCtaLink,
                ctaStyle: rest.ctCtaStyle,
                rows: rest.ctRows,
            },
            textContentBlock2 = {
                color: rest.tcb2BackgroundColor,
                textColor: rest.tcb2TextColor,
                title: rest.tcb2Title,
                fontSizeTitle: rest.tcb2FontSizeTitle,
                subTitle: rest.tcb2Subtitle,
                fontSizeSubTitle: rest.tcb2FontSizeSubtitle,
                ctaText1: rest.tcb2CtaText1,
                ctaLink1: rest.tcb2CtaLink1,
                ctaStyle1: rest.tcb2CtaStyle1,
                ctaText2: rest.tcb2CtaText2,
                ctaLink2: rest.tcb2CtaLink2,
                ctaStyle2: rest.tcb2CtaStyle2,
                ctaText3: rest.tcb2CtaText3,
                ctaLink3: rest.tcb2CtaLink3,
                ctaStyle3: rest.tcb2CtaStyle3,
            },
        } = {};

        return (
            <React.Fragment>
                <div className={`${styles.root}`}>
                    <TitleBloc {...rest} />
                    <Container>
                        <div className={`${styles.articleContainer}`}>
                            {buildComponentArray<ArticleProps>(
                                articles.iv,
                                (itemProps: ArticleProps, key: number): JSX.Element => {
                                    return (
                                        // eslint-disable-next-line react/no-array-index-key
                                        <div className={`${styles.article}`} key={key}>
                                            <Article {...itemProps} />
                                        </div>
                                    );
                                },
                            )}
                        </div>
                        <RibbonBlocContainer {...rest} />

                        {assets && (
                            <div className={styles.advantagesContainer}>
                                <AdvantageImagesBloc images={assets} />
                            </div>
                        )}
                        {imgs && (
                            <div className={styles.imagesContainer}>
                                <div className={styles.imagesSectionTitle}>{imagesTitle}</div>
                                <ImagesBloc images={imgs} hideFilters />
                            </div>
                        )}
                    </Container>
                    <div className={styles.separator} />
                    <TextContentBlock {...textContentBlock1} />
                    <div className={styles.separator} />
                    <div className={styles.stepsContainer}>
                        <StepListBlock steps={steps} />
                    </div>
                    <div className={styles.separator} />
                    <ComparisonTable {...comparisonTableProps} />
                    <div className={styles.separator} />
                    <TextContentBlock {...textContentBlock2} />
                    <div className={styles.separator} />
                    <Container>
                        {mentions && (
                            <div className={styles.mentions}>
                                <HtmlContainer htmlContent={mentions} />
                            </div>
                        )}
                    </Container>
                </div>
            </React.Fragment>
        );
    },
);
